"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var promotion_1 = __importDefault(require("~/components/estimate_banners/promotion"));
var form_1 = __importDefault(require("~/components/estimate_banners/inners/form"));
var EstimateBanner = function (props) {
    var form = (React.createElement(form_1.default, { path: props.path, analyticsData: props.analyticsData, userInsightEventData: props.userInsightEventData, importCategoryGroupId: props.importCategoryGroupId, importCategoryId: props.importCategoryId, importCategoryOptions: props.importCategoryOptions, itemName: props.itemName, itemCondition: props.itemCondition, itemConditionOptions: props.itemConditionOptions, blogId: props.blogId }));
    if (props.smartphone) {
        return (React.createElement("div", { className: "estimateEntryBanner-Main estimateEntryBanner-Main-withImage" },
            React.createElement("div", { className: "estimateEntryBanner-Main_BalloonWithCharacterArea" },
                React.createElement("div", { className: "estimateEntryBanner-Main_BalloonWrapper" },
                    React.createElement(promotion_1.default, { categoryName: props.categoryName, maxEstimateRequestSize: props.maxEstimateRequestSize, position: "right", withIcon: false, categoryIconClasses: props.categoryIconClasses, smartphone: true }))),
            React.createElement("div", null, form)));
    }
    else {
        return (React.createElement("div", { className: "estimateEntryBanner-Main estimateEntryBanner-Main-withImage" },
            React.createElement("div", { className: "estimateEntryBanner-Main_FormArea" },
                React.createElement("div", { className: "estimateEntryBanner-Main_PromotionContainer" },
                    React.createElement(promotion_1.default, { categoryName: props.categoryName, maxEstimateRequestSize: props.maxEstimateRequestSize, position: "bottom", withIcon: false, categoryIconClasses: props.categoryIconClasses })),
                form)));
    }
};
exports.default = EstimateBanner;
